import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ecgSelector } from '../../ecg/selectors/ecg.selectors';

export const DefaultView: React.FC = () => {
  const ecg = useSelector(ecgSelector);
  const navigate = useNavigate();

  navigate(`/${ecg.ecgId}/clustering/clean`, { replace: false });
  return <></>;
};
